export const STAGES = [
    { id: "nuovo", label: "Nuovo Lead", accent: "border-t-blue-400", dot: "bg-blue-400" },
    { id: "primo_contatto", label: "Primo contatto", accent: "border-t-cyan-400", dot: "bg-cyan-400" },
    { id: "visita_programmata", label: "Visita programmata", accent: "border-t-purple-400", dot: "bg-purple-400" },
    { id: "visita_effettuata", label: "Visita effettuata", accent: "border-t-indigo-400", dot: "bg-indigo-400" },
    { id: "trattativa", label: "Trattativa aperta", accent: "border-t-gold", dot: "bg-gold" },
    { id: "conclusa", label: "Conclusa", accent: "border-t-green-400", dot: "bg-green-400" },
    { id: "persa", label: "Persa", accent: "border-t-red-400", dot: "bg-red-400" },
];

export const stageLabel = (id) => [...STAGES, ...SELLER_STAGES].find((s) => s.id === id)?.label || id;

export const SELLER_STAGES = [
    { id: "da_valutare", label: "Da valutare", accent: "border-t-blue-400", dot: "bg-blue-400" },
    { id: "valutazione_fatta", label: "Valutazione fatta", accent: "border-t-cyan-400", dot: "bg-cyan-400" },
    { id: "incarico_proposto", label: "Incarico proposto", accent: "border-t-purple-400", dot: "bg-purple-400" },
    { id: "incarico_firmato", label: "Incarico firmato", accent: "border-t-gold", dot: "bg-gold" },
    { id: "in_vendita", label: "In vendita", accent: "border-t-green-400", dot: "bg-green-400" },
    { id: "venduto", label: "Venduto", accent: "border-t-emerald-500", dot: "bg-emerald-500" },
    { id: "perso", label: "Perso", accent: "border-t-red-400", dot: "bg-red-400" },
];

export const PRIORITIES = [
    { id: "alta", label: "Alta", cls: "text-red-300 bg-red-900/30 border-red-700/40" },
    { id: "media", label: "Media", cls: "text-amber-300 bg-amber-900/30 border-amber-700/40" },
    { id: "bassa", label: "Bassa", cls: "text-ink-400 bg-ink-900 border-white/10" },
];

export const priorityCls = (id) => PRIORITIES.find((p) => p.id === id)?.cls || PRIORITIES[1].cls;

const PRIORITY_BADGE = { alta: "vd-badge vd-badge-priority-alta", media: "vd-badge vd-badge-priority-media", bassa: "vd-badge vd-badge-priority-bassa" };
export const priorityBadgeCls = (id) => PRIORITY_BADGE[id] || PRIORITY_BADGE.media;

export const SOURCE_LABELS = {
    richiesta: "Richiesta contatto",
    messaggio: "Messaggio annuncio",
    visita: "Richiesta visita",
    manuale: "Inserito manualmente",
    idealista: "Idealista",
    immobiliare: "Immobiliare.it",
    casa_it: "Casa.it",
    subito: "Subito.it",
    email: "Email",
    annuncio_privato: "Nuovo Annuncio Privato",
    altro: "Altro",
};

export const KIND_LABELS = {
    creazione: "Creazione",
    nota: "Nota",
    stage: "Cambio fase",
    conversione: "Conversione",
    richiesta: "Richiesta contatto",
    messaggio: "Messaggio",
    visita: "Visita",
    attivita: "Attività",
};

export const fmtDate = (iso) => {
    if (!iso) return "—";
    try {
        return new Date(iso).toLocaleDateString("it-IT", { day: "2-digit", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit" });
    } catch {
        return iso;
    }
};
